import React from "react";

import "./Header.scss";
import logo from "../../assets/imgs/sysb_logo.svg";
import peopleIcon from "../../assets/imgs/people_icon_bk.svg";

export type HeaderProps = {
  userName: string;
  baseName: string;
};

const Header: React.FC<HeaderProps> = ({ userName, baseName }) => {
  return (
    <>
      <div className="header">
        <div className="logo">
          <img src={logo} alt="" />
        </div>
        <div className="roleArea">
          <div className="roleLogo">
            <img src={peopleIcon} alt="" />
          </div>
          <div className="userName">{userName}</div>
        </div>
        <div className="baseSelect">拠点選択</div>
        <select className="baseName">
          <option value={baseName}>{baseName}</option>
        </select>
      </div>
    </>
  );
};

export default Header;
